import React, { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { useBooking } from '../context/BookingContext';

const STORAGE_KEY = 'akira_promo_banner_dismissed_v1';

const PromoBanner = ({ onDismiss }) => {
  const [visible, setVisible] = useState(false);
  const { openBooking } = useBooking();

  useEffect(() => {
    try {
      const dismissed = window.localStorage.getItem(STORAGE_KEY);
      if (!dismissed) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore quota errors */
    }
    onDismiss?.();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="promo-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-rose-500 via-rose-400 to-rose-500 text-white shadow-md"
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between gap-4 py-2.5 text-sm">
          <div className="flex items-center gap-3 min-w-0">
            <Sparkles className="w-4 h-4 shrink-0" aria-hidden />
            <p className="truncate">
              <span className="hidden sm:inline font-semibold tracking-wide uppercase text-[11px] mr-2">
                First-Time Guests
              </span>
              <span>
                Enjoy <strong className="font-semibold">20% off</strong> your first treatment at Akira Signature Care.
              </span>
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <button
              type="button"
              onClick={() => openBooking('First-Time 20% Offer')}
              data-testid="promo-banner-cta"
              className="hidden sm:inline-flex items-center px-4 py-1 rounded-full bg-white text-rose-600 text-xs font-semibold tracking-wider uppercase hover:bg-stone-100 transition-colors"
            >
              Claim Offer
            </button>
            <button
              type="button"
              aria-label="Dismiss offer banner"
              onClick={dismiss}
              data-testid="promo-banner-dismiss"
              className="p-1 rounded-full hover:bg-white/20 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
